import { render, staticRenderFns } from "./PaymentHeader.vue?vue&type=template&id=0945bf55&scoped=true&"
import script from "./PaymentHeader.js?vue&type=script&lang=js&"
export * from "./PaymentHeader.js?vue&type=script&lang=js&"
import style0 from "./PaymentHeader.vue?vue&type=style&index=0&id=0945bf55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945bf55",
  null
  
)

export default component.exports